import API from './api';

export default {

    getTeams: (organization_id, supportsDefaults = false) => API({
        url: `teams?organization_id=${organization_id}&supportsDefaults=${supportsDefaults}`,
        method: 'GET',
    }),
    
    getTeam: (teamId, supportsDefaults = true) => API({
        url: `teams/${teamId}?supportsDefaults=${supportsDefaults}`,
        method: 'GET',
    }),

    createTeam: (team) => API({
        url: 'teams',
        method: 'POST',
        json: team,
    }),

    updateTeam: (team) => API({
        url: `teams/${team.id}`,
        method: 'PATCH',
        json: team,
    }),

    removeTeam: (teamId) => API({
        url: `teams/${teamId}`,
        method: 'DELETE',
    }),
    
};
